var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-sm-9\">\n<h4>\n<span ng-hide=\"booking.$link('event_chain')\">{{booking.service_name}}</span>\n<span ng-show=\"booking.$link('event_chain')\">{{booking.$link('event_chain').title}}</span>\n</h4>\n<wb-booking-details-list booking=\"booking\"></wb-booking-details-list>\n<div>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<button ng-repeat=\"action in actions\" type=\"button\" ng-click=\"action.action(booking)\" class=\"btn btn-default pull-right\" ng-disabled=\"action.disabled\" ng-if=\"action.label == 'Cancel'\">\n{{action.label}}\n</button>\n</div>\n</div>";
var id1="member/member-booking/member_booking.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/sdk-templates/member/member-booking/member_booking.html
// module id = 1254
// module chunks = 0